<template>
  <div id="app">
    <dv-full-screen-container class="all">
      <div class="content">
        <div class="top">
          <p class="top_name">智慧健康家庭</p>
          <p class="top_name1">SMART HEALTH HOME</p>
        </div>
        <div class="main">
          <div class="left">
            <div class="hospital">
              {{hospital_name}}
              <div class="other" @click="()=>showHospital=true"></div>
            </div>
            <div class="nurse">
              <div class="nurse_detail">
                <p>在线看护</p>
                <div class="flex">
                  <div class="nurse_item" v-for="(item,index) in nurseDataFive" :key="index">
                    <img :src="item.avatar">
                    <p>{{item.name}}</p>
                  </div>
                </div>
              </div>
              <img src="../src/assets/list.png" class="nurse_more">
            </div>
            <div class="call">
              <div style="height:45vh;overflow-y: scroll;">
                <light-timeline :items="callData" class="lightTimeline">
                  <template slot="tag" slot-scope="{ item }">
                    <span class="callTime">{{ item.date }}</span>
                  </template>
                  <template slot="content" slot-scope="{ item }">
                    <div class="lineSj callMsg">
                      <p style="margin:0 0 5px 0">{{ item.msg }}</p>
                      <p>健康家庭呼叫服务</p>
                    </div>
                  </template>
                </light-timeline>
              </div>
            </div>
            <div class="weather">
              <div>
                <iframe width="250" scrolling="no" height="60" frameborder="0" allowtransparency="true"
                  src="https://i.tianqi.com?c=code&id=35&color=%23FFFFFF&icon=1&site=34"></iframe>
                <p class="weatherDate">{{date}}</p>
                <p class="weatherTime">{{time}}</p>
              </div>

            </div>
          </div>
          <div class="right">
            <div class="item" v-for="(item,index) in roomData" :key="index">
              <div class="itemTop">
                <div class="itemTopLeft">
                  <img :src="item.disease_avatar">
                </div>
                <div class="itemTopRight">
                  <div class="info">
                    <div style="width:64%">
                      <p class="sickroomName">{{item.sickroom_name}}</p>
                      <p class="disease">
                        {{item.disease_name}}
                        <span style="margin:0 30px 0 50px" v-if="item.disease_sex==1">男</span>
                        <span style="margin:0 30px 0 50px" v-else>女</span>
                        <span>{{getAge(item.disease_birthday)}}岁</span>
                      </p>
                    </div>
                    <div class="model">
                      <img src="../src/assets/1.png" class="modelImg1" @click="linkTo3D(item.sickroom_id)">
                      <img src="../src/assets/2.png" class="modelImg2" @click="()=>showQJ=true">
                    </div>
                  </div>
                  <div class="but">
                    <div class="butItem"  :style="{'background-color': (item.warning?'red':'#00114A')}">
                      <img src="../src/assets/4.png">
                      <span>告警</span>
                    </div>
                    <div class="butItem">
                      <img src="../src/assets/3.png">
                      <span>卧床</span>
                    </div>
                    <div class="butItem">
                      <img src="../src/assets/5.png">
                      <span>厕所</span>
                    </div>
                    <div class="butItem">
                      <img src="../src/assets/6.png">
                      <span>运动</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="static">
                <p class="environment">
                  <MarqueeTips :speed="25" :content="item.environment"></MarqueeTips>
                </p>
                <div class="staticInfo">
                  <div class="staticItem">
                    <p><span>{{item.callCount}}</span>次</p>
                    <p>呼叫</p>
                  </div>
                  <div class="staticItem">
                    <p><span>{{item.leaveBedCount}}</span>次</p>
                    <p>离床</p>
                  </div>
                  <div class="staticItem">
                    <p><span>{{item.calCount}}</span>卡</p>
                    <p>运动量</p>
                  </div>
                  <div class="staticItem">
                    <p><span>{{item.deviceCount}}</span>个</p>
                    <p>设备</p>
                  </div>
                  <div class="staticItem">
                    <p><span>{{item.lookCount}}</span>次</p>
                    <p>看护</p>
                  </div>
                </div>
                <div class="chart">
                  <div class="chartTop" v-for="(item1,index1) in item.staticData" :key="index1">
                    <p @click="selected(item.sickroom_id,index1)" :class="{ activeClass:item1.chartSelect}">
                      {{item1.name}}
                    </p>
                  </div>
                </div>
                <div class="zx" :id="item.sickroom_id"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
    <el-dialog title="医院切换" :visible.sync="showHospital" width="30%">
      <div style="text-align:center">
        <el-select v-model="hospital_id" placeholder="请选择医院" style="width:60%">
          <el-option
            v-for="item in hospitalData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showHospital = false">取 消</el-button>
        <el-button type="primary" @click="changeHospital()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="3D模型" :visible.sync="show3D" width="80%" top="10vh">
      <el-row>
        <el-col :span="24">
          <div class="bimFace" ref="bimFace"></div>
        </el-col>
        <!-- <el-col :span="6">
          <button @click="handleAddModelLabe()">显示组件</button>
        </el-col> -->
      </el-row>
    </el-dialog>
    <el-dialog title="全景" :visible.sync="showQJ" width="80%" top="10vh">
      <iframe src="https://www.4dkankan.com/spc.html?m=KJ-RLcbamfClK" style="width:100%;height:80vh;border:0px"></iframe>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
  import MarqueeTips from 'vue-marquee-tips';
  import * as bimfaceHelper from '../utils/bimfaceHelper.js';
  import {hospitalList,monitorData,getViewToken} from '../api/home.js'
  export default {
    components: {
      MarqueeTips
    },
    name: 'home',
    data() {
      return {
        newDataTimer:'',
        showHospital: false,
        show3D: false,
        viewToken: '',
        showQJ:false,
        date: '',
        time: '',
        hospitalData:[],
        hospital_id:'',
        hospital_name: '广东省第二人民医院',
        nurseData: [{}],
        nurseDataFive: [
          {
            avatar: 'https://www.gd2h.com/Upload/201407/6354120514537500002662037.jpg',
            name: '罗友华'
          },
          {
            avatar: 'https://www.gd2h.com/Upload/201407/6354120614364062506520286.jpg',
            name: '郭洪娟'
          },
          {
            avatar: 'https://www.gd2h.com/Upload/201407/6354120562739062505904234.jpg',
            name: '陈春梅'
          },
          {
            avatar: 'https://www.gd2h.com/Upload/201502/6356062338096875004920280.jpg',
            name: '江小运'
          },
          {
            avatar: 'https://www.gd2h.com/Upload/201407/6354119346476562504221328.jpg',
            name: '唐迎红'
          }
        ],
        callData: [{
            date: "12:38",
            color: '#00FCFF',
            msg: "上门配送营养餐",
          },
          {
            date: "12:29",
            color: '#FFFFFF',
            msg: "上门送药",
          },
          {
            date: "12:11",
            color: '#FFFFFF',
            msg: "上门送药",
          },
          {
            date: "11:53",
            color: '#FFFFFF',
            msg: "上门配送营养餐",
          },
          {
            date: "11:37",
            color: '#FFFFFF',
            msg: "上门配送营养餐",
          },
          {
            date: "11:24",
            color: '#FFFFFF',
            msg: "上门配送营养餐",
          }
        ],
        roomData: []
      }
    },
    mounted() {
      let that = this;
      this.getHospital()
      this.timer = setInterval(() => {
        that.getDateTime()
      }, 1000);
    },
    methods: {
      async getHospital(){
        let res=await hospitalList();
        if(res.errno==0){
          this.hospitalData=res.data;
          if(this.hospitalData.length>0){
            this.hospital_name=this.hospitalData[0].name;
            this.hospital_id=this.hospitalData[0].id;
            let that=this
            that.getInfoList()
            this.newDataTimer = setInterval(() => {
              that.getInfoList()
            }, 1000*60);
          }
        }else{
          this.$message.error(res.errmsg);
        }
      },
      changeHospital(){
        this.showHospital = false
        for(var i in this.hospitalData){
          if(this.hospitalData[i].id==this.hospital_id){
            this.hospital_name=this.hospitalData[i].name
          }
        }
        this.getInfoList()
      },
      async getInfoList(){
        let params={
          hospital_id:this.hospital_id
        };
        let res=await monitorData(params);
        if(res.errno==0){
          this.roomData=res.data;
          console.log(this.roomData)
          let that=this;
          setTimeout(() => {
            that.init()
          }, 2000);
        }else{
          this.$message.error(res.errmsg);
        }
      },
      init() {
        for (var i in this.roomData) {
          let data = this.roomData[i].staticData;
          for (var j in data) {
            if (data[j].chartSelect == true) {
              var chartDom = document.getElementById(this.roomData[i].sickroom_id);
              var myChart = echarts.init(chartDom);
              var option;
              option = {
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  left: '5%',
                  right: '7%',
                  top: '10%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: data[j].xData,
                  axisLabel: {
                    color: '#FFFFFF'
                  }
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    color: '#FFFFFF'
                  },
                  splitLine: {
                    show: false
                  }
                },
                series: data[j].series
              };
              myChart.setOption(option,true);
            }
          }
        }
      },
      selected(sickroom_id, index) {
        for (var i in this.roomData) {
          if (this.roomData[i].sickroom_id == sickroom_id) {
            let data = this.roomData[i].staticData;
            for (var j in data) {
              data[j].chartSelect = false;
            }
            data[index].chartSelect = true;
            var chartDom = document.getElementById(sickroom_id);
            var myChart = echarts.init(chartDom);
            var option;
            option = {
              tooltip: {
                trigger: 'axis'
              },
              grid: {
                left: '5%',
                right: '7%',
                top: '10%',
                containLabel: true
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data[index].xData,
                axisLabel: {
                  color: '#FFFFFF'
                }
              },
              yAxis: {
                type: 'value',
                axisLabel: {
                  color: '#FFFFFF'
                },
                splitLine: {
                  show: false
                }
              },
              series: data[index].series
            };
            data[index].series
            myChart.setOption(option,true);
          }
        }
      },
      getDateTime() {
        var timeStamp = new Date();
        let year = timeStamp.getFullYear()
        let month = timeStamp.getMonth() + 1 < 10 ? '0' + (timeStamp.getMonth() + 1) : timeStamp.getMonth() + 1
        let date = timeStamp.getDate() < 10 ? '0' + timeStamp.getDate() : timeStamp.getDate()
        let hh = timeStamp.getHours() < 10 ? '0' + timeStamp.getHours() : timeStamp.getHours()
        let mm = timeStamp.getMinutes() < 10 ? '0' + timeStamp.getMinutes() : timeStamp.getMinutes()
        let ss = timeStamp.getSeconds() < 10 ? '0' + timeStamp.getSeconds() : timeStamp.getSeconds()
        this.date = year + '-' + month + '-' + date
        this.time = hh + ':' + mm + ':' + ss
      },
      getAge(birthday) {
        var birthDayTime = new Date(birthday).getTime();
        var nowTime = new Date().getTime();
        return Math.ceil((nowTime - birthDayTime) / 31536000000);
      },
      async linkTo3D(sickroom_id) {
        let params={
          sickroom_id:sickroom_id
        };
        let res=await getViewToken(params)
        if(res.errno==0){
          this.viewToken=res.data.viewToken;
          this.show3D = true;
          let that=this;
          setTimeout(() => {
            that.handleLoadModel()
          }, 2000);
        }else{
          this.$message.error(res.errmsg);
        }
      },
      //加载模型
      handleLoadModel() {
        bimfaceHelper.destroyViewer();
        bimfaceHelper.loadModel(this.viewToken, this.$refs.bimFace);
      },
      //销毁模型
      handleDestroyModel(){
        bimfaceHelper.destroyViewer();
      },
      //模型显示组件
      handleAddModelLabe(){
        let position = {
          x: 18097.63050377211,
          y: -27709.518616825357,
          z: 706.3599243164061
        };
        let labe_list = ['1', '2', '3'];
        labe_list.push(new Date().getTime())
        bimfaceHelper.addComponent(position, labe_list)
      }
    }
  }
</script>

<style>
  .el-dialog__body{
    padding:0px  !important
  }
  p {
    margin: 0;
  }

  .flex {
    display: flex;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* font-family: PingFangSC-Regular; */
    font-weight: 400;
    width: 100vw;
    height: 100vh;
  }

  .all {
    width: 100vw;
    height: 100vh;
    background-color: #0b1547;
  }

  .content {
    width: 100vw;
    height: 100vh;
  }

  .top {
    width: 100vw;
    height: 74px;
    background-image: url(assets/header.png);
    background-position: 50% 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .top_name {
    font-size: 2rem;
    color: #fff;
    text-align: center;
    letter-spacing: 8px;
  }

  .top_name1 {
    font-size: 1.3rem;
    color: #fff;
    text-align: center;
  }

  .main {
    margin: 10px 20px;
    display: flex;
  }

  .left {
    width: 20vw;
    margin-right: 1vw;
  }

  .hospital {
    height: 8vh;
    background: #081438;
    box-shadow: inset 0 1px 18px 0 rgba(0, 238, 255, 0.50);
    line-height: 8vh;
    font-size: 1.6rem;
    color: #fff;
    text-indent: 1.5vw;
    position: relative
  }

  .other {
    position: absolute;
    top: 5px;
    right: 8px;
    width: 0;
    height: 0;
    border-top: 15px solid #00f4ff;
    border-left: 15px solid transparent;
    cursor: pointer;
  }

  .nurse {
    margin-top: 1vh;
    height: 14vh;
    background: #081438;
    box-shadow: inset 0 1px 18px 0 rgba(0, 238, 255, 0.50);
    padding-top: 10px;
    font-size: 1.1rem;
    color: #fff;
    position: relative
  }

  .nurse_detail {
    padding: 0.3vh 1vw
  }

  .nurse_item {
    width: 55px;
    text-align: center;
    font-size: 16px;
    margin: 0px 7px
  }

  .nurse_item img {
    width: 55px;
    height: 55px;
    border-radius: 30px;
    margin-top: 10px;
  }

  .nurse_more {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 20px;
    height: 20px
  }

  .lightTimeline {
    color: #ffffff
  }

  .call {
    margin-top: 1vh;
    padding-top:1vh;
    height: 46vh;
    background: rgba(8, 20, 56, 0.50);
    box-shadow: inset 0 1px 18px 0 rgba(0, 238, 255, 0.50);
  }

  .callTime {
    font-size: 18px;
    color: #ffffff
  }

  .callMsg {
    color: #ffffff;
    position: relative;
    font-size: 16px;
    background-color: rgba(12, 22, 54, 1);
    border: 1px solid rgba(0, 252, 255, 1);
    padding: 8px 15px;
    border-radius: 10px;
    margin-top: -10px;
  }

  .weather {
    margin-top: 1vh;
    width: 100%;
    height: 17vh;
    background: #081438;
    box-shadow: inset 0 1px 18px 0 rgba(0, 238, 255, 0.50);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff
  }

  .weatherDate {
    font-size: 18px;
    font-weight: 400;
  }

  .weatherTime {
    color: #00FBFE;
    font-size: 40px;
  }

  .right {
    width: 79vw;
    height: 91vh;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
  }

  ::-webkit-scrollbar {
    width: 0 !important
  }

  .item {
    width: 24.5vw;
    height: 44.5vh;
    margin-right: 1vw;
    background: #040c26;
    box-shadow: inset 0 1px 18px 0 rgba(0, 238, 255, 0.50);
    margin-bottom: 1vh;
    color: #ffffff;
  }

  .itemTop {
    height: 10.5vh;
    display: flex;
  }

  .itemTopLeft {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .itemTopLeft img {
    width: 65px;
    height: 65px;
    border-radius: 35px;
  }

  .itemTopRight {
    flex-grow: 1;
  }

  .info {
    display: flex;
    padding: 8px 0px 4px 0
  }

  .sickroomName {
    margin: 3px 0;
    font-size: 18px;
    font-weight: 400;
  }

  .disease {
    font-size: 17px;
    font-weight: 400;
  }

  .model {
    width: 35%;
    display: flex
  }

  .modelImg1 {
    width: 45px;
    height: 45px;
    margin-right: 15px
  }

  .modelImg2 {
    width: 43px;
    height: 43px;
  }

  .but {
    display: flex;
    color: #fff;
    font-size: 15px;
    margin-top: 2px
  }

  .butItem {
    width: 22%;
    margin-right: 3%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00114A;
    border-radius: 4px;
    padding: 4px 0px
  }

  .butItem img {
    width: 20px;
    height: 20px
  }

  .environment {
    font-size: 15px;
    margin: 5px 15px
  }

  .static {
    height: 34vh;
    box-shadow: inset 7px -5px 12px -7px #00F4FF, inset -7px -5px 12px -7px #00F4FF;
    border-top: 1px solid rgba(255, 255, 255, 0.5)
  }

  .staticInfo {
    background-color: #1a2139;
    display: flex;
    margin: 10px 16px 0px 16px;
    padding: 0px 10px 5px 10px
  }

  .staticItem {
    width: 20%;
    text-align: center;
    font-size: 15px
  }

  .staticItem span {
    font-size: 23px;
  }

  .lineSj:before,
  .lineSj:after {
    position: absolute;
    content: '';
    border: 10px solid;
  }

  .lineSj:before {
    left: -20px;
    top: 8px;
    border-color: transparent #00F4FF transparent transparent;
  }

  .lineSj:after {
    border-color: transparent #0C1636 transparent transparent;
    left: -18px;
    top: 8px;
  }

  .line-container::after {
    width: 2px !important;
    background-color: rgba(255, 255, 255, 0.26) !important;
  }

  .chart {
    background-color: #0a153c;
    display: flex;
    margin: 0px 16px;
  }

  .chartTop {
    width: 12.5%;
    text-align: center;
    font-size: 15px
  }

  .chartTop p {
    text-align: center;
    padding: 5px 5px;
    margin-right: 3px;
    cursor: pointer;
  }

  .activeClass {
    box-shadow: inset 0px 0px 5px #00F4FF;
    border: 1px solid #ffffff
  }

  .zx {
    width: 100%;
    height: 26vh
  }
  
  .bimFace {
    width: 100%;
    height: 80vh;
  }
</style>
